export class Plant {
  VegetationName: string;
  Species: string;
  ParkId: string;
  headline: string;
  description: string;
  file?: string;
  vegetationNoteId: string;
  vegetationPhotoId: string;
}
